var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartInHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "5 5 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24.654l3.281-3.029m0 0L26 8.5l14.219 13.125m-28.438 0V43.5H40.22V21.625m0 0l3.281 3.029",
    stroke: "#1BB2C5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.085 38.748l-.817-.694c-.88-.75-1.677-1.509-2.553-2.352a84.812 84.812 0 01-2.053-2.024 20.412 20.412 0 01-1.921-2.074 9.141 9.141 0 01-.786-1.28 5.91 5.91 0 01-.705-2.541c-.002-2.145 1.601-3.937 3.898-4.394 1.866-.368 3.705.616 4.853 1.938 1.142-1.325 2.982-2.313 4.84-1.95 2.296.45 3.903 2.233 3.909 4.338a5.58 5.58 0 01-.256 1.673 7.47 7.47 0 01-1.272 2.403 27.632 27.632 0 01-2.38 2.503 71.717 71.717 0 01-3.953 3.751l-.804.703zm-4.13-13.846c-.165 0-.332.015-.497.048-1.542.307-2.619 1.456-2.618 2.796.029.617.206 1.25.526 1.843.188.373.4.72.639 1.05a19.25 19.25 0 001.772 1.905c.681.7 1.361 1.358 2.04 2.01a59.46 59.46 0 002.254 2.092 71.045 71.045 0 003.661-3.49 26.278 26.278 0 002.257-2.37c.434-.549.77-1.185.987-1.874.122-.389.183-.79.183-1.194-.004-1.334-1.082-2.479-2.623-2.78-1.514-.301-3.137.859-3.831 2.147l-.697 1.291-.702-1.287c-.626-1.147-1.99-2.187-3.35-2.187z",
    fill: "#1BB2C5"
  })));
}

export default SvgHeartInHouse;